module.exports = __webpack_public_path__ + "img/gatorz-youtube.a9a76b6d.png";